import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Core from './scripts/core.js'

Vue.config.productionTip = true

const core = new Core(store)
Vue.prototype.core = core

//Update Vuex if localstorage loginstate changed.
router.beforeEach((from, to, next) => {
	let user = localStorage.getItem('user')
	let originalUser = store.state.user

	if(!(user === null && originalUser === null) && (user === null || originalUser === null || user != JSON.stringify(originalUser))) {
		core.commit('setUser', JSON.parse(user))
	}

	next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
